/*
Monotype Foundry Platform API
Version 1.0.0

Definition: Promotion

Properties:
  actualStatus: string
  allFonts: string (required)
  allowedPackages: string
  createdAt: string
  discount: string
  egc: string
  endDate: string (required)
  familyIds: array
  foundry: object (required)
  id: string
  image: object
  owner: object
  promoTitle: string (required)
  promotionSKUs: array (required)
  promotionTypeId: number (required)
  releaseDate: string
  secretCode: string
  sentStatus: string
  startDate: string (required)
  status: string (required)
  transferStatus: boolean
  isMarketing: boolean
  updatedAt: string
*/

var Promotion = (function () {
  function validatePromotion (arg) {
    // Validate actualStatus
    if (arg.actualStatus && !(typeof arg.actualStatus === 'string')) {
      throw new Error('Promotion.actualStatus: Wrong type: Got \'' + (typeof arg.actualStatus) + '\', but expected: \'string\'')
    }
    // Validate allFonts
    if (!arg.allFonts) {
      throw new Error('Promotion.allFonts: Missing property')
    }
    if (arg.allFonts && !(typeof arg.allFonts === 'string')) {
      throw new Error('Promotion.allFonts: Wrong type: Got \'' + (typeof arg.allFonts) + '\', but expected: \'string\'')
    }
    // Validate discount
    if (arg.discount && !(typeof arg.discount === 'string')) {
      throw new Error('Promotion.discount: Wrong type: Got \'' + (typeof arg.discount) + '\', but expected: \'string\'')
    }
    // Validate endDate
    if (!arg.endDate) {
      throw new Error('Promotion.endDate: Missing property')
    }
    if (arg.endDate && !(typeof arg.endDate === 'string')) {
      throw new Error('Promotion.endDate: Wrong type: Got \'' + (typeof arg.endDate) + '\', but expected: \'string\'')
    }
    // Validate foundry
    if (!arg.foundry) {
      throw new Error('Promotion.foundry: Missing property')
    }
    if (arg.foundry && !(typeof arg.foundry === 'object')) {
      throw new Error('Promotion.foundry: Wrong type: Got \'' + (typeof arg.foundry) + '\', but expected: \'object\'')
    }
    // Validate promoTitle
    if (!arg.promoTitle) {
      throw new Error('Promotion.promoTitle: Missing property')
    }
    if (arg.promoTitle && !(typeof arg.promoTitle === 'string')) {
      throw new Error('Promotion.promoTitle: Wrong type: Got \'' + (typeof arg.promoTitle) + '\', but expected: \'string\'')
    }
    // Validate promotionSKUs
    if (!arg.promotionSKUs) {
      throw new Error('Promotion.promotionSKUs: Missing property')
    }
    if (arg.promotionSKUs && !(Array.isArray(arg.promotionSKUs))) {
      throw new Error('Promotion.promotionSKUs: Wrong type: Got \'' + (typeof arg.promotionSKUs) + '\', but expected: \'array\'')
    }
    // Validate promotionTypeId
    if (!arg.promotionTypeId) {
      throw new Error('Promotion.promotionTypeId: Missing property')
    }
    if (arg.promotionTypeId && !(typeof arg.promotionTypeId === 'number')) {
      throw new Error('Promotion.promotionTypeId: Wrong type: Got \'' + (typeof arg.promotionTypeId) + '\', but expected: \'number\'')
    }
    // Validate releaseDate
    if (arg.releaseDate && !(typeof arg.releaseDate === 'string')) {
      throw new Error('Promotion.releaseDate: Wrong type: Got \'' + (typeof arg.releaseDate) + '\', but expected: \'string\'')
    }
    // Validate secretCode
    if (arg.secretCode && !(typeof arg.secretCode === 'string')) {
      throw new Error('Promotion.secretCode: Wrong type: Got \'' + (typeof arg.secretCode) + '\', but expected: \'string\'')
    }
    // Validate sentStatus
    if (arg.sentStatus && !(typeof arg.sentStatus === 'string')) {
      throw new Error('Promotion.sentStatus: Wrong type: Got \'' + (typeof arg.sentStatus) + '\', but expected: \'string\'')
    }
    // Validate startDate
    if (!arg.startDate) {
      throw new Error('Promotion.startDate: Missing property')
    }
    if (arg.startDate && !(typeof arg.startDate === 'string')) {
      throw new Error('Promotion.startDate: Wrong type: Got \'' + (typeof arg.startDate) + '\', but expected: \'string\'')
    }
    // Validate status
    if (!arg.status) {
      throw new Error('Promotion.status: Missing property')
    }
    if (arg.status && !(typeof arg.status === 'string')) {
      throw new Error('Promotion.status: Wrong type: Got \'' + (typeof arg.status) + '\', but expected: \'string\'')
    }
  }
  function buildPromotion (arg) {
    var Promotion = arg
    // Complete actualStatus
    // Expected Type: string
    Promotion.actualStatus = Promotion.actualStatus || ''
    // Complete allFonts
    // Expected Type: string
    Promotion.allFonts = Promotion.allFonts || ''
    // Complete discount
    // Expected Type: string
    Promotion.discount = Promotion.discount || ''
    // Complete endDate
    // Expected Type: string
    Promotion.endDate = Promotion.endDate || ''
    // Complete foundry
    // Expected Type: object
    Promotion.foundry = Promotion.foundry || {}
    // Complete promoTitle
    // Expected Type: string
    Promotion.promoTitle = Promotion.promoTitle || ''
    // Complete promotionSKUs
    // Expected Type: array
    Promotion.promotionSKUs = Promotion.promotionSKUs || []
    // Complete promotionTypeId
    // Expected Type: number
    Promotion.promotionTypeId = Promotion.promotionTypeId || 0
    // Complete releaseDate
    // Expected Type: string
    Promotion.releaseDate = Promotion.releaseDate || ''
    // Complete secretCode
    // Expected Type: string
    Promotion.secretCode = Promotion.secretCode || ''
    // Complete sentStatus
    // Expected Type: string
    Promotion.sentStatus = Promotion.sentStatus || ''
    // Complete startDate
    // Expected Type: string
    Promotion.startDate = Promotion.startDate || ''
    // Complete status
    // Expected Type: string
    Promotion.status = Promotion.status || ''
    return Promotion
  }
  return {
    validate: validatePromotion,
    build: buildPromotion
  }
})()

module.exports = Promotion
